import { Box, Grid, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ShowWithAlphabetItems, nameItems, paidByItems, rowsPerPageItems } from './payrollConstants';
import { formatAmountCommaSeperator, formatDateToShow, getItemsLength } from '../../../common/Common';

import { EnhancedDropDownRHF } from '@websential/cosmic-v20'
import { Link } from 'react-router-dom';
import { ProcessPayrollDropDown } from '../../ProcessPayrollDropDown';
import { ProcessPayrollDropDownRHF } from '../../ProcessPayrollDropDown/ProcessPayrollDropDownRHF';

interface IPayrollSetupHeaderPanel {
    payFrequencyDDLItems: { label: string, value: string }[];
    onFrequencyChangeHandler: (selected: any) => void
    payrollPeriodsDDL: { label: string, value: string }[];
    onPayrollPeriodsDDLChangeHandler: (selected: any) => void
    departmentsDDLItems: any;
    payrollTableData: any;
    selectedpayPeriodIndex: number | null;
    payPeriodStarDate: string | null;
    payPeriodEndDate: string | null;
    summary: any;
    onClickImportPayrollDataHandler: any;

    onChangeNameFilter: (selected: any) => void;
    onChangePaidByFilter: (selected: any) => void;
    ShowWithAlphabetFilter: (selected: any) => void;
    onChangeDepartmentsFilter: (selected: any) => void;
    onChangeRowsPerPageFilter: (selected: any) => void;
    onChangePageFilter: (selected: any) => void;
    general_settings: any
    payrollDataItems: any
    calculatedPayrollDataItems: any
    openRollbackDialogue?: any
    gridsMaxTotalWidth?: any
    pageSizeStored?: any
}
export const PayrollSetupHeaderPanel: React.FC<IPayrollSetupHeaderPanel> = ({ payFrequencyDDLItems, onFrequencyChangeHandler, payrollPeriodsDDL, onPayrollPeriodsDDLChangeHandler, departmentsDDLItems, payrollTableData, payPeriodStarDate, payPeriodEndDate, selectedpayPeriodIndex, summary, onClickImportPayrollDataHandler,

    onChangeNameFilter,
    onChangePaidByFilter,
    ShowWithAlphabetFilter,
    onChangeDepartmentsFilter,
    onChangeRowsPerPageFilter,
    onChangePageFilter,
    general_settings,
    payrollDataItems,
    calculatedPayrollDataItems,
    openRollbackDialogue,
    gridsMaxTotalWidth,
    pageSizeStored
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));
    const isMediumScreen1 = useMediaQuery(theme.breakpoints.between(1195, 1550));
    const isMediumScreen2 = useMediaQuery(theme.breakpoints.between(1550, 1660));
    const mobileTabOrScreen = isMobile || isSmallScreen;
    const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen || isMediumScreen01;
    const totalEmployee =
        getItemsLength(payrollDataItems) +
        getItemsLength(calculatedPayrollDataItems);

    const [pageItems, setPageItems] = useState<
        { label: string; value: number }[]
    >([]);

    useEffect(() => {
        if (payrollTableData?.total && payrollTableData?.size) {
            const pageSize =
                pageSizeStored && pageSizeStored !== payrollTableData.size
                    ? pageSizeStored
                    : payrollTableData.size;
            const pageCount = Math.ceil(
                payrollTableData.total / pageSize
            );


            const items = Array.from({ length: pageCount }, (_, index) => ({
                label: `Page : ${String(index + 1)}`,
                value: index + 1,
            }));

            setPageItems(items);
        } else {
            setPageItems([]);
        }
    }, [payrollTableData, pageSizeStored]);


    return (
        <div
            style={{
                width: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%",
                minWidth: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%"
            }}
        >
            {openRollbackDialogue && openRollbackDialogue ? <></> :
                <Grid
                    container
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    sx={{
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderBottom: 0,
                        borderRadius: "2px 2px 0 0",
                        padding: "31px 20px 1rem 20px"
                    }}
                    columnSpacing={2}
                >
                    {/* <Grid
                    size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
                    sx={{ mt: "12px", "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" }, maxWidth: "16rem" }}
                >
                    <EnhancedDropDownRHF
                        selectName="payFrequencyDDLItems"
                        testId={`payFrequencyDDLItems-list`}
                        items={payFrequencyDDLItems ?? []}
                        onSelectionChangeHandler={onFrequencyChangeHandler}
                    />
                    <ProcessPayrollDropDownRHF
                        selectName="payrollPeriodsDDL"
                        testId={`payrollPeriodsDDL`}
                        items={payrollPeriodsDDL ?? []}
                        onSelectionChangeHandler={onPayrollPeriodsDDLChangeHandler}
                    />
                    {selectedpayPeriodIndex !== null && <span style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}>Pay Period#{selectedpayPeriodIndex + 1}</span>} <br />
                    {payPeriodEndDate && (<span style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}>{formatDateToShow(payPeriodStarDate)} to {formatDateToShow(payPeriodEndDate)}</span>)}
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 0.5, lg: 0.5, xl: 0.5 }} sx={{ maxWidth: "3rem" }}></Grid>
                {summary && <><Grid
                    size={{ xs: 12, sm: 3, md: 1, lg: 1, xl: 1 }}
                    sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", maxWidth: "8rem" }}
                >
                    Employees {totalEmployee && totalEmployee}
                    <br /> Paid {summary && summary.paidEmployees}
                    <br />
                    Inactive {summary && summary.inactiveEmployees}
                </Grid>
                    <Grid
                        size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                        sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", maxWidth: "16rem" }}
                    >
                        Paid By Cheque {summary && summary.paidByCheque}
                        <br /> Paid By Direct Deposit {summary && summary.paidByDirectDeposit}
                        <br />
                        Cheque Amount ${formatAmountCommaSeperator(summary && summary.chequeAmount)}
                        <br />
                        Direct Deposit Amount ${formatAmountCommaSeperator(summary && summary.directDepositAmount)}
                    </Grid>
                    <Grid
                        size={{ xs: 12, sm: 3, md: 1.5, lg: 1.5, xl: 1.5 }}
                        sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
                    >
                        <span style={{ height: "10px", width: "10px", background: "#E5FFE8" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Earning</span>
                        <br />
                        <span style={{ height: "10px", width: "10px", background: "#FFF2F2" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Deduction</span>
                        <br />
                        <span style={{ height: "10px", width: "10px", background: "#F6E5FF" }}>&nbsp;&nbsp;&nbsp;</span>&nbsp;
                        <span>Reimbursement</span>

                    </Grid></>}
                <Grid
                    size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                    sx={{
                        textAlign: "right",
                        color: "rgba(0, 0, 0, 0.6)",
                        fontSize: "0.875rem",
                        marginLeft: "auto"
                    }}
                >
                    <Link
                        to={`/reports/payroll`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Payroll Report
                    </Link>
                    <br />
                    <Link
                        to={`/reports/timesheet`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Time Sheet Report
                    </Link>
                    <br />
                    <Link
                        to={`#`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                        onClick={onClickImportPayrollDataHandler}
                    >
                        Import Payroll Data
                    </Link>
                    <br />
                    Statutory Holiday Eligibility <br />
                    <Link
                        to={`/settings/general/setup`}
                        className="no-underline"
                        style={{ color: theme.palette.primary.light }}
                    >
                        Time format
                    </Link> {general_settings && general_settings.timeFormat === 100 ? "1.50" : "1.30"} = 1 hr 30 mins.
                </Grid>*/}

                    {/* EVERYTHING THAT SHOULD STAY ON THE LEFT */}
                    <Box
                        sx={{
                            position: "sticky",
                            left: 22,
                            // zIndex: 20,
                            zIndex: 2,
                            backgroundColor: "#fff",

                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,

                            // Important if horizontal scrolling is happening
                            flexShrink: 0,
                        }}
                    >
                        {/* Pay Frequency + Pay Period */}
                        <Grid
                            size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
                            sx={{
                                mt: "12px",
                                width: "16rem!important",
                                maxWidth: "16rem",
                                flexShrink: 0,

                                "& .dropDownWrapper .dropDownField__menu": {
                                    zIndex: "999!important",
                                },
                            }}
                        >
                            <EnhancedDropDownRHF
                                selectName="payFrequencyDDLItems"
                                testId="payFrequencyDDLItems-list"
                                items={payFrequencyDDLItems ?? []}
                                onSelectionChangeHandler={onFrequencyChangeHandler}
                            />

                            <ProcessPayrollDropDownRHF
                                selectName="payrollPeriodsDDL"
                                testId="payrollPeriodsDDL"
                                items={payrollPeriodsDDL ?? []}
                                onSelectionChangeHandler={onPayrollPeriodsDDLChangeHandler}
                            />

                            {selectedpayPeriodIndex !== null && (
                                <>
                                    <span
                                        style={{
                                            color: "rgba(0, 0, 0, 0.6)",
                                            fontSize: "0.875rem",
                                        }}
                                    >
                                        Pay Period#{selectedpayPeriodIndex + 1}
                                    </span>
                                    <br />
                                </>
                            )}

                            {payPeriodEndDate && (
                                <span
                                    style={{
                                        color: "rgba(0, 0, 0, 0.6)",
                                        fontSize: "0.875rem",
                                    }}
                                >
                                    {formatDateToShow(payPeriodStarDate)} to{" "}
                                    {formatDateToShow(payPeriodEndDate)}
                                </span>
                            )}
                        </Grid>

                        {/* Spacer */}
                        <Box
                            sx={{
                                width: "3rem",
                                minWidth: "3rem",
                                flexShrink: 0,
                            }}
                        />

                        {/* Employees */}
                        {summary && (
                            <Grid
                                sx={{
                                    color: "rgba(0, 0, 0, 0.6)",
                                    fontSize: "0.875rem",
                                    width: "8rem",
                                    minWidth: "8rem",
                                    flexShrink: 0,
                                }}
                            >
                                Employees {totalEmployee || 0}
                                <br />
                                Paid {summary.paidEmployees}
                                <br />
                                Inactive {summary.inactiveEmployees}
                            </Grid>
                        )}

                        {/* Payment Summary */}
                        {summary && (
                            <Grid
                                sx={{
                                    color: "rgba(0, 0, 0, 0.6)",
                                    fontSize: "0.875rem",
                                    width: "16rem",
                                    minWidth: "16rem",
                                    flexShrink: 0,
                                }}
                            >
                                Paid By Cheque {summary.paidByCheque}
                                <br />
                                Paid By Direct Deposit {summary.paidByDirectDeposit}
                                <br />
                                Cheque Amount $
                                {formatAmountCommaSeperator(summary.chequeAmount)}
                                <br />
                                Direct Deposit Amount $
                                {formatAmountCommaSeperator(summary.directDepositAmount)}
                            </Grid>
                        )}

                        {/* Legend */}
                        {summary && (
                            <Grid
                                sx={{
                                    color: "rgba(0, 0, 0, 0.6)",
                                    fontSize: "0.875rem",
                                    width: "12rem",
                                    minWidth: "12rem",
                                    flexShrink: 0,
                                }}
                            >
                                <span
                                    style={{
                                        height: "10px",
                                        width: "10px",
                                        background: "#E5FFE8",
                                        display: "inline-block",
                                    }}
                                />
                                &nbsp; Earning
                                <br />

                                <span
                                    style={{
                                        height: "10px",
                                        width: "10px",
                                        background: "#FFF2F2",
                                        display: "inline-block",
                                    }}
                                />
                                &nbsp; Deduction
                                <br />

                                <span
                                    style={{
                                        height: "10px",
                                        width: "10px",
                                        background: "#F6E5FF",
                                        display: "inline-block",
                                    }}
                                />
                                &nbsp; Reimbursement
                            </Grid>
                        )}
                    </Box>

                    {/* RIGHT SIDE — NOT STICKY */}
                    <Grid
                        size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                        sx={{
                            textAlign: "right",
                            color: "rgba(0, 0, 0, 0.6)",
                            fontSize: "0.875rem",
                            marginLeft: "auto",
                            flexShrink: 0,
                        }}
                    >
                        <Link
                            to="/reports/payroll"
                            className="no-underline"
                            style={{ color: theme.palette.primary.light }}
                        >
                            Payroll Report
                        </Link>

                        <br />

                        <Link
                            to="/reports/timesheet"
                            className="no-underline"
                            style={{ color: theme.palette.primary.light }}
                        >
                            Time Sheet Report
                        </Link>

                        <br />

                        <Link
                            to="#"
                            className="no-underline"
                            style={{ color: theme.palette.primary.light }}
                            onClick={onClickImportPayrollDataHandler}
                        >
                            Import Payroll Data
                        </Link>

                        <br />

                        Statutory Holiday Eligibility
                        <br />

                        <Link
                            to="/settings/general/setup"
                            className="no-underline"
                            style={{ color: theme.palette.primary.light }}
                        >
                            Time format
                        </Link>{" "}
                        {general_settings?.timeFormat === 100 ? "1.50" : "1.30"} = 1 hr 30 mins.
                    </Grid>

                </Grid>
            }
            {payrollTableData && payrollTableData.items && payrollTableData.items.length === 0 &&
                payrollTableData && payrollTableData.total === 0 ? <></> : payrollTableData && payrollTableData.total !== 0 &&
            <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderBottom: 0,
                    borderRadius: "2px 2px 0 0",
                    padding: "31px 5px 0 5px",
                    "& .dropDownWrapper": { marginBottom: "0!important" },
                    "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" }
                }}
                columnSpacing={2}
            >
                <Box
                    sx={{
                        position: !mobileTabOrScreen ? "sticky" : "unset",
                        zIndex: 1, 
                        left: 6,
                        display: "flex",
                        gap: 2,
                        backgroundColor: "#fff",
                        width: "fit-content",
                    }}
                >
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                        }}>

                        <EnhancedDropDownRHF
                            selectName="name"
                            testId={`name`}
                            items={nameItems}
                            selectedItem={"firstName"}
                            onSelectionChangeHandler={onChangeNameFilter}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                        }}>
                        <EnhancedDropDownRHF
                            selectName="ShowWithAlphabet"
                            testId={`ShowWithAlphabet`}
                            items={ShowWithAlphabetItems}
                            selectedItem={"all"}
                            onSelectionChangeHandler={ShowWithAlphabetFilter}
                        /></Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                        }}>
                        <EnhancedDropDownRHF
                            selectName="paidBy"
                            testId={`PaidBy`}
                            items={paidByItems}
                            onSelectionChangeHandler={onChangePaidByFilter}
                            selectedItem={"all"}
                        /></Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                        }}>
                        <EnhancedDropDownRHF
                            selectName="departments"
                            testId={`departments`}
                            selectedItem={"all"}
                            onSelectionChangeHandler={onChangeDepartmentsFilter}
                            items={departmentsDDLItems ?? []}
                        /></Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                        }}>
                        <EnhancedDropDownRHF
                            selectName="rowsPerPageItems"
                            testId={`rowsPerPageItems`}
                            items={rowsPerPageItems}
                            selectedItem={100}
                            onSelectionChangeHandler={onChangeRowsPerPageFilter}
                        /></Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{
                            maxWidth: isMediumScreen1 ? "8rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "8rem" : isMediumScreen01 ? "8rem" : "12rem",
                        }}>
                        <EnhancedDropDownRHF
                            selectName="page"
                            testId={`page`}
                            items={pageItems}
                            selectedItem={payrollTableData && payrollTableData?.page}
                            onSelectionChangeHandler={onChangePageFilter}
                        /></Grid></Box>
            </Grid>}

        </div>
    )
}

